import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Button, Col, PageHeader, Panel, Form, FormGroup, Modal, FormControl, InputGroup, Row, ControlLabel } from 'react-bootstrap';
import keydown from 'react-keydown';
import _ from 'lodash';
import moment from 'moment';
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';

import CancelOrderModal from '../modals/CancelOrderModal.js';
import UnassignOrderModal from '../modals/UnassignOrderModal.js'
import getCurLang from '../../businessLogic/getCurLang.js';
import { parseExpectedPickUpTimeOnlyTime } from '../../businessLogic/expectedPickUpTimeParser.js';
import { formatTime } from '../../businessLogic/deliveryTimeFormatter.js';
import getOrderType from '../../businessLogic/getOrderType.js';
import { formatCashOn } from '../../businessLogic/formatCashOnDelivery.js';
import formatCamelCase from '../../businessLogic/formatCamelCase.js';
import setOrderStatusColor from '../../businessLogic/setOrderStatusColor.js';
import LoopbackHttp from '../../businessLogic/LoopbackHttp.js';
import * as appActions from '../../actions/appActions';
import { gettext } from '../../i18n/service.js';
import './OrderDetailModal.scss';

class OrderDetailModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showModal:props.show,
      baseApiUrl: process.env.BASE_API
    }
    _.bindAll(this, ['close', 'open', 'renderOrderDetails', 'renderItems', 'getVehicle', 'renderCreatedByDetails', 'renderRecipientDetails',
                    'renderFooter', 'renderDriverDetails', 'cancelOrder']);


  }

  componentDidMount() {
    this.props.appActions.getOrder(this.props.order.id)
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.fetchedOrder !== this.props.fetchedOrder) {
      console.log(nextProps.fetchedOrder)
    }
  }

  componentWillUnmount() {
    this.props.appActions.clearFetchedOrder();
  }

  @keydown( 'esc' )
    onEscKeyDown() {
      this.close();
    }

  getVehicle(type) {
    return _.find(this.props.vehicles, { size: type });
  }
  close() {
    this.props.clearModalFromState();
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  renderOrderDetails() {
    const getDeliveryPoint = (recipient) => {
      if (!recipient || !recipient.outOfCityAddress)
        return <span>{gettext('CANT-GET-DELIVERY-POINT')} </span>
      return (
        <span>
          <span>{gettext('COUNTRY')}: </span>{recipient.outOfCityAddress.country}<br />
          <span>{gettext('CITY')}: </span>{recipient.outOfCityAddress.city}<br />
          <span>{gettext('ADDRESS-LINE-FIRST')}: </span>{recipient.outOfCityAddress.addressFirst}<br />
          <span>{gettext('ADDRESS-LINE-SECOND')}: </span>{recipient.outOfCityAddress.addressSecond}<br />
          <span>{gettext('ZIP-CODE')}: </span>{recipient.outOfCityAddress.zipCode}<br />
        </span>
      )
    }

    let recipient = this.props.fetchedOrder.recipient;
console.log("recipient", recipient)

    return (
      <Row>
        <Col sm={12} className="user_data center_div">
          <Row className="header">
            <Col sm={6}>
              <ControlLabel><h5 style={{whiteSpace: 'nowrap'}}>{gettext('ORDER#')} {this.props.fetchedOrder.id}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{gettext('DATE') + ' '}{moment(this.props.fetchedOrder.createdAt).format('L')}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('STATUS')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{formatCamelCase(this.props.fetchedOrder.orderStatus)}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('PICKUP-TIME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{parseExpectedPickUpTimeOnlyTime(this.props.fetchedOrder.expectedPickUpTime)}  {moment(+this.props.fetchedOrder.expectedPickUpTime.endTime).format('MM/DD')}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('DELIVERY-TIME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{formatTime(this.props.fetchedOrder.deliveryTime)}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('ORDER-TYPE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{getOrderType(this.props.fetchedOrder)}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('VEHICLE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{formatCamelCase(this.getVehicle(parseInt(this.props.fetchedOrder.vehicleType)).type)}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('DELIVER-TO')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              {
                this.props.order.isOutOfCity
                  ? getDeliveryPoint(recipient)
                  : <label><h5>{recipient.deliveryPoint == "floating"?gettext('RECIPIENT-ADDRESS-UNDEFINED'):recipient.deliveryPoint}</h5></label>
              }
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('ITEMS')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.items.length}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('CASH-ON-DELIVERY')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{formatCashOn(this.props.fetchedOrder.cashOnDelivery, this.props.fetchedOrder.cashOnDeliveryAmount)}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('ORDER-PRICE-TYPE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.isFixed ? gettext('FIXED-PRICE') : gettext('DISTANCE-BASED')}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('TOTAL')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.deliveryCommission || gettext('CANNOT-GET-DELIVERY-COMMISSION')}</h5></label>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
  renderItems() {
    return this.props.fetchedOrder.items.map((item, index) => {
      const point = item.pickUpPoint ?
        item.pickUpPoint :
        gettext('CANNOT-GET-PICKUP-POINT');

      return (
        <Row key={index}>
          <Col sm={12} className="user_data center_div">
            <Row className="header">
              <Col sm={6}>
                <ControlLabel><h5>{gettext('ITEM#')} {item.id.slice(item.id.length - 5, item.id.length)}</h5></ControlLabel>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <ControlLabel><h5>{gettext('PICKUP-POINT')}</h5></ControlLabel>
              </Col>
              <Col sm={6} className="text-right">
                <ControlLabel><h5>{point.address?point.address:point}</h5></ControlLabel><br />
                {point.contactName ?
                  <ControlLabel><h5>{point.contactName}</h5></ControlLabel>
                  : ''}
                <br />
                {point.phone ?
                  <ControlLabel><h5>{point.phone}</h5></ControlLabel>
                  : ''}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <ControlLabel><h5>{gettext('PACKING-LIST')}</h5></ControlLabel>
              </Col>
              <Col sm={6} className="text-right">
                <ControlLabel><h5>{item.packingList}</h5></ControlLabel>
              </Col>
            </Row>
            {item.comment
              ? <Row>
                <Col sm={6}>
                  <ControlLabel><h5>{gettext('COMMENT')}</h5></ControlLabel>
                </Col>
                <Col sm={6} className="text-right">
                  <ControlLabel><h5>{item.comment}</h5></ControlLabel>
                </Col>
              </Row>
              : ''
            }
          </Col>
        </Row>
      );
    })
  }

  renderRecipientDetails() {
    let recipient = this.props.fetchedOrder.recipient;
    return (
      <Row>
        <Col sm={12} className="user_data center_div">
          <Row className="header">
            <Col sm={6}>
              <ControlLabel><h5>{gettext('RECIPIENT')}</h5></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('NAME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{recipient?recipient.firstName:''}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('PHONE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{recipient?recipient.mobile:''}</h5></label>
            </Col>
          </Row>
         </Col>
      </Row>
    );
  }

  renderCreatedByDetails() {
    return (
      <Row>
        <Col sm={12} className="user_data center_div">
          <Row className="header">
            <Col sm={6}>
              <ControlLabel><h5>{gettext('CREATED-BY')}</h5></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('COMPANY-NAME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.createdBy.companyName}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('NAME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.createdBy.name}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('PHONE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{this.props.fetchedOrder.createdBy.phone}</h5></label>
            </Col>
          </Row>
         </Col>
      </Row>
    );
  }

  renderDriverDetails(driver) {
    return (
      <Row>
        <Col sm={12} className="user_data center_div">
          <Row className="header">
            <Col sm={6}>
              <ControlLabel><h5>{gettext('DRIVER-INFO')}</h5></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('NAME')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{driver.firstName}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('PHONE')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{driver.phone}</h5></label>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel><h5>{gettext('DRIVER-COMMISSION')}</h5></ControlLabel>
            </Col>
            <Col sm={6} className="text-right">
              <label><h5>{driver.driverCommissionPercent}%</h5></label>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  cancelOrder(order) {
    if (order.orderStatus === 'canceled') {
      return this.props.showMessage({
        message: gettext('ORDER-CANNOT-BE-CANCELED.CANCELED-ALREADY'),
        level: 'error'
      });
    }
    if (order.orderStatus !== 'new') {
      return this.props.showMessage({
        message: gettext('ORDER-CANNOT-BE-CANCELED'),
        level: 'error'
      });
    }
    // this.props.showMessage({
    //   message: order.id + ' ' + gettext('HAS-BEEN-CANCELED'),
    //   level: 'success'
    // });
    this.props.appActions.startSpinner();
    this.props.appActions.updateLocalOrder(order, { orderStatus: 'canceled' });
    this.props.cancelOrder(order);
  }

  updateOrder(e, order) {
    e.preventDefault();
    e.stopPropagation();
    this.props.clearModalFromState();
    this.props.appActions.setOrderForUpdate(order);
    this.props.router.push('/updateOrder');
  }

  unassignOrder(orderId) {
    this.props.unassignOrder(orderId);
  }

  renderFooter() {
    return (
      <Row>
        <div className="botom_line" />
        <Col sm={12} className="user_data center_div footer">
          {/* <Row> */}
            <Col sm={2}>
            </Col>
            {
              this.props.fetchedOrder.orderStatus === 'new'?
              <Col sm={4}>
                <Button className="btn-update" onClick={(e) => this.updateOrder(e, this.props.fetchedOrder, this.props.fetchedOrder.pickUpPoints)} block>{gettext('UPDATE')}</Button>
              </Col> : ''
            }
            {
              this.props.fetchedOrder.orderStatus !== 'canceled' && this.props.fetchedOrder.orderStatus !== 'delivered' ?
              <Col sm={4}>
                <CancelOrderModal
                  closeOrderDetailsModal ={this.close}
                  cancelOrder={this.cancelOrder}
                  order={this.props.fetchedOrder} />
              </Col> : ''
            }
            {
              this.props.canUnassign ?
              <Col sm={4}>
                <UnassignOrderModal
                  closeOrderDetailsModal ={this.close}
                  unassignOrder={this.props.unassignOrder}
                  order={this.props.fetchedOrder} />
              </Col> : ''
            }
            <Col sm={2}>
            </Col>
          {/* </Row> */}
        </Col>
      </Row>
    );
  }
  render() {
    const order = this.props.fetchedOrder;
    const driver = this.props.fetchedOrder.driver;

    return this.props.fetchedOrder.id ? (
      <div style={{display: 'inline'}}>
        <Link onClick={this.open}>
          {this.props.link}
        </Link>
        <Modal className="modal-center" show={this.state.showModal}
          onHide={this.close} bsSize="lg">
          <Modal.Header closeButton>
            <Modal.Title>{gettext('ORDER.ORDER-DETAILS')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="row border-between" id="order-detail-info">
              <Col sm={6} className="col-right-border">
                {this.renderOrderDetails()}
              </Col>
              <Col sm={6} className="col-left-border">
                {!LoopbackHttp.isDispatcher ? this.renderCreatedByDetails() : ''}

                {this.renderRecipientDetails()}

                {driver && !LoopbackHttp.isDispatcher?
                  this.renderDriverDetails(driver) : ''
                }
                {this.renderItems()}
              </Col>
            </Row>            
          </Modal.Body>
          <Modal.Footer>
            <Row className="row border-between">
              <Col sm={6} className="col-right-border">
                {this.renderFooter()}
              </Col>
              <Col sm={6} className="col-right-border">
                <div className="botom_line"/>
                <a className="btn btn-default" href={`${this.state.baseApiUrl}Orders/getAsPdf?orderId=${this.props.fetchedOrder.id}`} target="new">
                  Get PDF
                </a>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    fetchedOrder: state.appReducer.fetchedOrder
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderDetailModal);



// WEBPACK FOOTER //
// ./src/components/modals/OrderDetailModal.js